module.exports = __webpack_public_path__ + "../static/img/cadastro2.92d48a64.png";